export default __webpack_public_path__ + "static/media/icon_maintenance_started.ae29ea1f.svg";